import React, { FC } from 'react';
import { Body } from '@indigo-ag/component-module';

import { NewPage } from '../NewPage/NewPage';

export const NoMatch: FC = () => {
  return (
    <NewPage title="404 Not Found">
      <Body>No match for the current path.</Body>
    </NewPage>
  );
};
